import {
  InputProps as HeadlessInputProps,
  Input as HeadlessInput,
  Field,
  Label,
} from "@headlessui/react";
import React, { RefObject, FC, ReactNode } from "react";

const BaseRadioInput: FC<HeadlessInputProps> = (props) => (
  <HeadlessInput
    className="disabled:border-swdc-gray-200 group-hover:not-disabled:border-swdc-blue-300 checked:border-swdc-blue-500 size-4 appearance-none rounded-full border group-hover:not-checked:border-1 checked:border-5 active:not-checked:not-disabled:border-2 disabled:opacity-75"
    {...props}
  />
);

export type RadioInputProps = HeadlessInputProps & {
  type: "radio";
  ref?: RefObject<HTMLInputElement>;
} & (
    | {
        variant: "form";
        label?: string | ReactNode;
      }
    | {
        variant: "without-label";
      }
  );
/**
 * DO NOT USE!
 * USE THE FACADE COMPONENT `Input` INSTEAD.
 */
export const RadioInput: FC<RadioInputProps> = (props) => {
  switch (props.variant) {
    case "form":
      return (
        <Field className="group flex w-fit gap-x-4">
          <BaseRadioInput {...props} />
          <Label className="group-hover:cursor-pointer">{props.label}</Label>
        </Field>
      );
    case "without-label":
    default: {
      return <BaseRadioInput {...props} />;
    }
  }
};
